import React, { FocusEvent, useEffect, useState } from 'react';

import moment from 'moment';
import Typography from 'antd/es/typography';

import { Calendar2Line } from '@assets/icons';
import dateInputMask from '@utils/dateInputMask';
import CustomIcon from '@components/utils/CustomIcon';
import { validRoomChildAge } from '@utils/dateUtil';
import { FlexibleDiv } from '@components/formStyles';

import {
  ChildDateAgeInput,
  DateInputContent,
  InputErrorBox,
  InputErrorText,
  StyledDateInput,
} from './DateInputStyle';
import { DateInputInterface } from './DateInputInterface';

const DateInput: React.FC<DateInputInterface> = (props) => {
  const {
    label,
    date,
    handleDatePick,
    error,
    isChild = false,
    maxAge = 15,
    regex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/,
    ...otherProps
  } = props;

  const wrapperRef = React.useRef(null);
  const inputRef = React.useRef<any>(null);
  const [isValidDate, setIsValidDate] = useState<boolean>(true);
  const [isValidDiffYears, setIsValidDiffYears] = useState<boolean>(false);

  const focusInput = (): void => {
    if (inputRef.current === null) return;
    inputRef.current.focus();
  };

  useEffect(() => {
    dateInputMask(inputRef.current);
  }, [handleDatePick]);

  const checkIsChild = (): boolean => {
    const isValid = validRoomChildAge(date as string, maxAge);
    setIsValidDiffYears(!isValid);
    return isValid;
  };

  useEffect(() => {
    if (date.toString().length === 10) {
      if (regex.test(String(date))) {
        isChild && checkIsChild();
        setIsValidDate(true);
      } else {
        handleDatePick(moment(), '');
        setIsValidDate(false);
      }
    }
  }, [date]);

  const onInputBlur = (event: FocusEvent<HTMLInputElement>): void => {
    if (!regex.test(event.target.value)) {
      handleDatePick(moment(), '');
      return setIsValidDate(false);
    }
  };

  return (
    <StyledDateInput
      ref={wrapperRef}
      data-testid='date-input-child-wrapper'
      className={error ? 'input-error' : 'input-normal'}
      onClick={focusInput}
    >
      <FlexibleDiv bottom={8}>
        <Typography.Text className='date-input-title'>{label}</Typography.Text>
      </FlexibleDiv>

      <div
        className={
          error || !isValidDate
            ? 'date-input-wrapper-error date-input-wrapper'
            : 'date-input-wrapper'
        }
      >
        <CustomIcon icon={Calendar2Line} fontSize={16} paletteColor='grey500' />

        <DateInputContent>
          <ChildDateAgeInput
            id='child-date-input'
            className='setur-input'
            data-testid='date-input-testid'
            ref={inputRef}
            maxLength={10}
            placeholder={date ? String(date) : 'GG/AA/YYYY'}
            type='string'
            onChange={(a) => {
              handleDatePick(moment(), a.target.value);
            }}
            value={date && date.toString()}
            onBlur={onInputBlur}
            {...otherProps}
          />
        </DateInputContent>
      </div>
      {isValidDate && isValidDiffYears ? (
        <InputErrorBox>
          <InputErrorText>Girilen çocuk yaşı hatalıdır.</InputErrorText>
        </InputErrorBox>
      ) : null}
      {error && !(isValidDate && isValidDiffYears) ? (
        <InputErrorBox>
          <InputErrorText>Bu alanı boş bırakamazsınız</InputErrorText>
        </InputErrorBox>
      ) : null}
    </StyledDateInput>
  );
};

export default DateInput;
